module.exports = __webpack_public_path__ + "img/n_Logo.9412d466.svg";